import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import {
  AttendanceMessageDatasetType,
  AttendanceMessageType,
  CourseUserActivityType,
} from "../../shared/types/attendance";

import { createReplaceAllReducer } from "store/utils";

type AttendanceState = {
  courseUserActivities: Record<string, CourseUserActivityType>;
};

const defaultState: AttendanceState = {
  courseUserActivities: {},
};

const initialState = () => defaultState;

const updateUserActivityInstance = (state: AttendanceState, activity: CourseUserActivityType) => {
  state.courseUserActivities[activity.userId] = activity;
};

export const AttendanceStore = createSlice({
  name: "attendance",
  initialState,
  reducers: {
    // TODO: refactor this when we have a better idea of other data we'll be receiving
    updateAnalytics: (state, action: PayloadAction<CourseUserActivityType[]>) => {
      action.payload.forEach((activity) => {
        updateUserActivityInstance(state, activity);
      });
    },
    updateAnalyticsRecord: (state, action: PayloadAction<AttendanceMessageType>) => {
      if (action.payload.datasetType === AttendanceMessageDatasetType.COURSE_USER_ACTIVITY) {
        updateUserActivityInstance(state, action.payload);
      }
    },
  },
  extraReducers: createReplaceAllReducer<AttendanceState>("attendance", initialState),
});

export const attendanceStateActions = AttendanceStore.actions;
